import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NavigationContextType {
  unreadNotifications: number;
  setUnreadNotifications: (count: number) => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [unreadNotifications, setUnreadNotifications] = useState<number>(3);

  return (
    <NavigationContext.Provider value={{ unreadNotifications, setUnreadNotifications }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = (): NavigationContextType => {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};